module.exports = __webpack_public_path__ + "static/media/willemHoyngs.2e68a32d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/willemHoyngs.jpg
// module id = 1702
// module chunks = 1